import { render } from "./MetricCard.vue?vue&type=template&id=1bc4e18b&scoped=true&lang=pug"
import script from "./MetricCard.vue?vue&type=script&lang=js"
export * from "./MetricCard.vue?vue&type=script&lang=js"

import "./MetricCard.vue?vue&type=style&index=0&id=1bc4e18b&lang=scss&scoped=true"
import "./MetricCard.vue?vue&type=style&index=1&id=1bc4e18b&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc4e18b"]])

export default __exports__